export default {
  methods: {
    // Converts bytes to readable format
    readableBytes(bytes) {
      const i = Math.floor(Math.log(bytes) / Math.log(1024));
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      // If bytes === 0 give back 0, otherwise readable bytes
      return bytes ? `${(bytes / (1024 ** i)).toFixed(2) * 1} ${sizes[i]}` : `${0} B`;
    },

    // Takes full location as an argument and returns the nested upload folder location
    buildFileLocation(location) {
      return location && `${process.env.VUE_APP_API_URL}${location.replace('api/library', 'library/download')}`;
    },


    getImageSize() {
      this.loaded = false;
      const img = new Image();
      img.src = this.imgSrc;
      img.onload = function () {
        this.height = img.naturalHeight;
        this.width = img.naturalWidth;
        this.loaded = true;
      }.bind(this);
    },

    fetchFileDetails(filename) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await this.axios.get(`library/${filename}`);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },

    fetchLibraryFile(filename) {
      this.fetchFileDetails(filename)
        .then((res) => {
          this.file = res.data.file;
          if (this.file.type === 'image') {
            this.imgSrc = this.buildFileLocation(res.data.file.location);
            this.getImageSize();
          } else {
            this.loaded = true;
          }
          this.fileData = res.data.file;
        })
        .catch((error) => {
          console.warn(error);
        });
    },
  },
  computed: {
    isImage() {
      return this.fileData.type === 'image';
    },
  },
};
